
        import i18n from 'i18n';
        import flattenObject from 'util/flattenObject';
    
            import ns812799c6c3ad182b988619c303141ae7en from './en.yaml'
            i18n.addResourceBundle('en', '812799c6c3ad182b988619c303141ae7', flattenObject(ns812799c6c3ad182b988619c303141ae7en), true, true);
        
        export default '812799c6c3ad182b988619c303141ae7';
    